import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTopOfPageContent } from "@faire/retailer-visitor-shared/stores/ui/useTopOfPageContent";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import { HorizontalLine } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Anchor as AnchorTag } from "@faire/web--source/ui/LinkAnchor";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React, { Suspense } from "react";
import styled from "styled-components";
import { BrandReviewsFallback, LazyBrandReviewsList } from "@faire/retailer/views/brand/BrandReview";
export var ReviewsSection = function(param) {
    var brand = param.brand, product = param.product, productReviewSummary = param.productReviewSummary, brandReviewSummary = param.brandReviewSummary;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var headerHeight = useTopOfPageContent().headerHeight;
    if (!brand || !product || !brandReviewSummary) {
        return null;
    }
    var _brandReviewSummary_numberOfReviews;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(HorizontalLine, {}),
            /*#__PURE__*/ _jsx(Anchor, {
                id: "brand-reviews-summary",
                style: {
                    top: "".concat(-headerHeight, "px")
                }
            }),
            /*#__PURE__*/ _jsx(WhenVisibilityIsImminent, {
                forceRender: isPrerender(),
                customizePlaceholder: /*#__PURE__*/ _jsx(BrandReviewsFallback, {}),
                children: /*#__PURE__*/ _jsx(Suspense, {
                    fallback: /*#__PURE__*/ _jsx(BrandReviewsFallback, {}),
                    children: /*#__PURE__*/ _jsxs(SectionsWrapper, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: {
                                    mobileAndAbove: "3x",
                                    tabletAndAbove: "5x"
                                }
                            }),
                            /*#__PURE__*/ _jsx(LazyBrandReviewsList, {
                                title: strictLocalize({
                                    id: "boyZeD",
                                    defaultMessage: [
                                        {
                                            type: 6,
                                            value: "reviewsCount",
                                            options: {
                                                one: {
                                                    value: [
                                                        {
                                                            type: 7
                                                        },
                                                        {
                                                            type: 0,
                                                            value: " brand review"
                                                        }
                                                    ]
                                                },
                                                other: {
                                                    value: [
                                                        {
                                                            type: 7
                                                        },
                                                        {
                                                            type: 0,
                                                            value: " brand reviews"
                                                        }
                                                    ]
                                                }
                                            },
                                            offset: 0,
                                            pluralType: "cardinal"
                                        }
                                    ]
                                }, backwardsCompatibleValues({
                                    reviewsCount: (_brandReviewSummary_numberOfReviews = brandReviewSummary === null || brandReviewSummary === void 0 ? void 0 : brandReviewSummary.numberOfReviews) !== null && _brandReviewSummary_numberOfReviews !== void 0 ? _brandReviewSummary_numberOfReviews : 0
                                })),
                                brand: brand,
                                product: product,
                                brandReviewSummary: brandReviewSummary,
                                productReviewSummary: productReviewSummary,
                                brandToken: brand.token,
                                brandName: brand.name,
                                brandAvatar: brand.squared_image,
                                productToken: product.token,
                                containerName: "product-page"
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: {
                                    mobileAndAbove: "3x",
                                    tabletAndAbove: "5x"
                                }
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var Anchor = styled(AnchorTag).withConfig({
    componentId: "sc-105dc8ef-0"
})([
    "display:block;position:relative;visibility:hidden;",
    "{top:0;}"
], responsiveMediaQueries.mobile);
var SectionsWrapper = styled.div.withConfig({
    componentId: "sc-105dc8ef-1"
})([
    "padding:",
    ";",
    "{padding:",
    ";}"
], getSpacing(0, "2x"), responsiveMediaQueries.desktopAndAbove, getSpacing(0, "6x"));
